import * as React from "react";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { Button, Box } from "@mui/material";
import "../blockpay.css";
import { setAuthToken } from "../../utils/setAuthToken";
import axios from "axios";

export default function Deposits2(props) {
  
  return (
    <React.Fragment>
      <Box sx={{ textAlign: "left", bottom: 0 }}>
        <Box
          component="img"
          sx={{ height: "80px", marginBottom: "25px" }}
          alt="Image"
          src={props.img}
        />

        <Typography
          component="p"
          variant="body1"
          sx={{
            color: "white",
            fontWeight: "400",
            fontSize: "1.125rem",
            width: "100%",
            marginBottom: "0.8rem",
          }}
        >
          {props.data}
        </Typography>
        <Typography
          variant="h4"
          sx={{
            flex: 1,
            color: "white",
            fontSize: "2rem",
            fontWeight: "600",
            lineHeight: "2.125rem!important",
          }}
        >
          {props.num}
        </Typography>
      </Box>
    </React.Fragment>
  );
}
